import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { genericProfileImg } from 'src/app/services/data/generic-profile';

type ImageType = 'round' | 'square'
type ImageSize = 'small' | 'medium' | 'large'

@Component({
    selector: 'app-user-image',
    template: `
  <img [src]="getStandardizedImage(image || genericPersonIMG)" [class]="getImageClass()" />
  `,
  imports: [CommonModule],
  
  standalone: true
})
export class UserImageComponent {
@Input() image: string | undefined | null
@Input() type?: ImageType = 'round'
@Input() size?: ImageSize = 'small'
  genericPersonIMG: string = genericProfileImg


getImageClass() {
  let imageClass = 'border-round rounded-lg '
  switch(this.size) {
    case 'small':
      imageClass += 'w-12 h-12 shadow-lg '
      break
    case 'medium':
      imageClass += 'w-24 h-24 shadow-lg '
      break
    case 'large':
      imageClass += 'w-48 h-48 shadow-lg '
      break

  }
  if(this.type === 'round') {
    imageClass += 'rounded-full'
  }
  return imageClass
}

getStandardizedImage(image: string): string {
  if(image.startsWith('data:image/jpeg;base64,')) {
    return image
  }
  return 'data:image/jpeg;base64,' + image
}
}
